import { SVGIconComponent } from './types';

export const EventNotificationWebhook: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/event-notif-wh" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="np_plug_2795643_000000" transform="translate(2.000000, 2.000000)" fill="currentColor" fillRule="nonzero">
        <path
          d="M16.43297,2.24095466 C15.7554544,1.84967303 14.9667449,1.69299007 14.1911672,1.79452475 C13.414738,1.89606616 12.693435,2.24969413 12.1384522,2.80117691 L9.61743246,5.33181286 L14.6682114,10.3825526 L17.198867,7.85191663 L17.198867,7.85279215 C17.7503317,7.29693963 18.1039915,6.57566469 18.205527,5.800093 C18.3070669,5.02366978 18.1503805,4.23584044 17.7590936,3.55741129 L20,1.31652229 L18.6738316,0 L16.43297,2.24095466 Z"
          id="Path"
        ></path>
        <path
          d="M1.32612359,20 L3.56702999,17.759111 C4.24367168,18.1547624 5.0323811,18.3140896 5.80972912,18.2125325 C6.58705473,18.1118673 7.30920923,17.7547189 7.86154784,17.1988887 L10.3825675,14.6682528 L9.44855775,13.7342503 L11.5870547,11.5957699 L10.2705222,10.2792476 L8.1328992,12.4186019 L7.58143454,11.8671415 L9.71993152,9.72866117 L8.40339901,8.41213888 L6.26490203,10.5506193 L5.33089224,9.61661672 L2.801133,12.1385132 C2.24966835,12.6934918 1.8960085,13.4147667 1.79447303,14.1912123 C1.69293308,14.9667616 1.84961949,15.7554649 2.2409064,16.4329977 L0,18.6738867 L1.32612359,20 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
);
